import OmikujiTestRoute from "@/views/omikujiTest/OmikujiTestRoute";
import OmikujiTest from "@/views/omikujiTest/OmikujiTest";

export default {
  path: "/omikuji/test",
  component: OmikujiTestRoute,
  children: [
    {
      path: ":id",
      name: "OmikujiTest",
      component: OmikujiTest
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/omikujiTest/index.js